// @flow

import cookies, { type CookieOptions } from 'js-cookie';
import isBrowser from '../isBrowser';

export default (name: string, value: string, options: CookieOptions): void => {
  if (!isBrowser()) {
    return;
  }
  cookies.set(name, value, options);
};
